module.exports = __webpack_public_path__ + "img/avg_premium_white.224fab3.svg";